export default __webpack_public_path__ + "static/media/noresults.6d8eefac.svg";